import PropTypes from 'prop-types';
import styled from '@emotion/styled';
import theme from '../../../styles/theme';

import { Text } from '..';

const ToggleContainer = styled.label`
  box-sizing: border-box;
  user-select: none;

  &:hover {
    cursor: pointer;
  }

  &:active {
    opacity: 0.7;
  }
`;

const ToggleSwitch = styled.div`
  display: flex;
  align-items: center;
  transition: background-color 0.2 ease-out;
  font-size: ${theme.fontSizes.sm};
  font-weight: bold;
  border: 1px solid ${theme.colors.primary};
  border-radius: ${theme.surface.borderRadius};
  height: ${theme.buttonSizes.sm};
  padding: 0 ${theme.spacing.s};
  margin: 0;
  background-color: ${theme.colors.white};
  color: ${theme.colors.primary};
  box-sizing: border-box;

  &:hover {
    cursor: pointer;
  }

  &:active {
    opacity: 0.7;
  }
`;

const ToggleInput = styled.input`
  display: none;

  &:checked + div {
    background-color: ${theme.colors.primary};
    color: ${theme.colors.white};
  }

  &:disabled + div {
    opacity: 0.7;
    cursor: not-allowed;

    &:after {
      opacity: 0.7;
    }
  }
`;

const ToggleBtn = ({ children, name, on, disabled, onClick, ...props }) => {
  const onToggle = async () => {
    await onClick();
  };

  return (
    <ToggleContainer {...props}>
      <ToggleInput
        type="checkbox"
        name={name}
        checked={on}
        disabled={disabled}
        onChange={onToggle}
      />
      <ToggleSwitch>
        <Text size="sm" color="inherit">
          {children}
        </Text>
      </ToggleSwitch>
    </ToggleContainer>
  );
};

ToggleBtn.propTypes = {
  children: PropTypes.string.isRequired,
  name: PropTypes.string,
  on: PropTypes.bool,
  disabled: PropTypes.bool,
  style: PropTypes.object,
  onClick: PropTypes.func,
};

ToggleBtn.defaultProps = {
  name: 'toggleButton',
  on: false,
  disabled: false,
  style: {},
  onClick: () => {},
};
export default ToggleBtn;
